import throttle from 'lodash.throttle';
import { useEffect, useState } from 'react';

function useNavButtonsDisabled(listRef) {
  const [prevButtonDisabled, setPrevButtonDisabled] = useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);

  useEffect(() => {
    const listElement = listRef.current;

    const throttleScroll = throttle(
      () => {
        if (listElement && listElement.scrollLeft === 0) {
          setPrevButtonDisabled(() => true);
        } else {
          setPrevButtonDisabled(() => false);
        }

        if (
          listElement.offsetWidth + listElement.scrollLeft >=
          listElement.scrollWidth
        ) {
          setNextButtonDisabled(() => true);
        } else {
          setNextButtonDisabled(() => false);
        }
      },
      400,
      { leading: false, trailing: true },
    );

    throttleScroll();
    listElement.addEventListener('scroll', throttleScroll, { passive: true });

    return () => {
      listElement.removeEventListener('scroll', throttleScroll);
      throttleScroll.cancel();
    };
  }, [listRef]);

  return { prevButtonDisabled, nextButtonDisabled };
}

export default useNavButtonsDisabled;
